import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIHoverActionController } from './UIHoverActionController.ts';
import { PieceTypes } from '@colonist/game-base-types';
import { getCardsForPiece } from '@colonist/game-card-types';
import { MechanicValidatorRoad } from '@colonist/game-mechanic-validators';
export class UIRoadHoverActionController extends UIHoverActionController {
    getBankActionAmount(index) {
        const myRoadPlayerState = this.roadValidator.getRoadPlayerState(this.uiGameManager.gameController.myColor);
        return myRoadPlayerState.bankRoadAmount;
    }
    updateState() {
        const useResources = true;
        const canPlaceRoad = this.roadValidator.canPlayerPlaceRoad(this.uiGameManager.gameController.myColor, useResources);
        this.updateHoverLocations(canPlaceRoad.validHoverLocations, canPlaceRoad.canTakeAction);
        this.uiGameManager.mapController.hoverController.onHoverStateChange();
    }
    getTexture(index) {
        return UIGameSpriteHandler.getRoadForPlayer(this.uiGameManager.gameController.myColor);
    }
    constructor(uiGameManager, roadState){
        super(uiGameManager);
        this.resources = getCardsForPiece(PieceTypes.Road);
        this.action = (index)=>this.uiGameManager.socketGameSend.confirmBuildRoadSkippingSelection(index);
        this.uiGameManager.mapController.hoverController.registerTileEdgeHoverAction(this);
        this.roadValidator = new MechanicValidatorRoad(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, roadState);
    }
}
